import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionChangeField } from "../../store/invoice/create/actions";
import {FormControl, InputLabel} from "@material-ui/core";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {EnumPackageType, FieldPackageTypeFC} from "./types";
const FieldPackageType: FieldPackageTypeFC = ({ saving }) => {
    const dispatch = useDispatch();
    const packageTypes = Object.values(EnumPackageType).filter(type => type !== EnumPackageType.NONE);
    const {value, error} = useSelector(
        ({
             invoice: {
                 create: {invoice, errors},
             },
         }) => ({
            value: invoice?.packageType ?? null,
            error: errors?.packageType ?? false,
        })
    );

    return (
        <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Выберите вид товара</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                fullWidth
                value={value}
                error={error}
                label={"Выберите вид товара"}
                onChange={(e, value) => {
                    dispatch(actionChangeField({ field: "packageType", value: e.target.value }));
                }}
            >
                {packageTypes.map((type) => (
                    <MenuItem key={type} value={type}>
                        {type}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default FieldPackageType;